<template>
  <v-card
    class="pa-6 mb-6"
    style="border-radius: 18px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06)"
  >
    <!-- Title & Toggle -->
    <v-card-title
      class="text-h6 font-weight-bold d-flex justify-space-between align-center"
    >
      <span>Ad Details</span>
      <div>
        <v-icon
          small
          @click="exitReview"
          style="font-size: 23px; margin-right: 1rem"
        >
          {{ isEditing ? "mdi-check" : "mdi-pencil" }}
        </v-icon>
        <v-icon small @click="expanded = !expanded" class="cursor-pointer">
          {{ expanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
        </v-icon>
      </div>
    </v-card-title>

    <!-- Expand transition wrapper -->
    <v-expand-transition>
      <div v-show="expanded">
        <v-card-text>
          <v-container fluid>
            <v-row>
              <!-- Left Column -->
              <v-col cols="12" md="7">
                <v-row>
                  <v-col cols="12" class="mb-4">
                    <div class="label">Ad name</div>
                    <div class="value">
                      {{ store.adCreativeData.adName || "video views ad" }}
                    </div>
                  </v-col>

                  <v-col
                    cols="12"
                    class="mb-4"
                    v-if="store.addacounts.facebook"
                  >
                    <div class="label mb-4">Ad identity</div>

                    <div class="value d-flex flex-column ga-2 mt-1">
                      <div class="d-flex align-center ga-2">
                        <img
                          :src="
                            require('@/components/SuperApp/ReviewPageIcon/facebook.svg')
                          "
                          width="20"
                          class="mr-1"
                        />
                        {{ store.addacounts.facebook.name }}
                      </div>

                      <div
                        v-if="store.addacounts.instagram"
                        class="d-flex align-center ga-2"
                      >
                        <img
                          :src="
                            require('@/components/SuperApp/ReviewPageIcon/insta.svg')
                          "
                          width="20"
                          class="mr-1"
                        />
                        {{ store.addacounts.instagram.name }}
                      </div>

                      <div
                        v-if="store.addacounts.snapchat"
                        class="d-flex align-center ga-2"
                      >
                        <img
                          :src="
                            require('@/components/SuperApp/ReviewPageIcon/snap.svg')
                          "
                          width="20"
                          class="mr-1"
                        />
                        {{ store.addacounts.snapchat.name }}
                      </div>

                      <div
                        v-if="store.addacounts.tiktok"
                        class="d-flex align-center ga-2"
                      >
                        <img
                          :src="
                            require('@/components/SuperApp/ReviewPageIcon/tiktok.svg')
                          "
                          width="20"
                          class="mr-1"
                        />
                        {{ store.addacounts.tiktok.name }}
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12" class="mb-4">
                    <div class="label">Ad format</div>
                    <div class="value">{{ store.format }}</div>
                  </v-col>

                  <v-col cols="12" class="mb-4">
                    <div class="label">Status</div>
                    <div class="value">
                      {{ store.adCreativeData.status ? "Active" : "Inactive" }}
                    </div>
                  </v-col>

                  <v-col cols="12" v-if="store.adCreativeData.websiteUrl">
                    <div class="label">Website URL</div>
                    <div class="value">
                      {{ store.adCreativeData.websiteUrl }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Right Column: Preview (Placeholder for now) -->
              <v-col cols="12" md="5"> </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import { useSuperAddStore } from "@/store/superAddStore";
export default {
  name: "AdDetails",
  data() {
    return {
      expanded: true,
      store: useSuperAddStore(),
    };
  },
  methods: {
    exitReview() {
      // ترجع خطوة معينة، وليكن 2
      this.$emit("exit-review");
      this.$emit("go-to-step", 2);
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 4px;
}
.value {
  font-size: 15px;
  color: #222;
}
</style>
